/**
 * Key — a single on-screen keyboard key.
 */
import React, { useCallback } from 'react';
import { TILE_STATE } from '../../utils/constants';

const stateClasses = {
  unused: 'bg-key-bg dark:bg-key-bg-dark text-gray-900 dark:text-white',
  [TILE_STATE.CORRECT]: 'bg-correct text-white',
  [TILE_STATE.PRESENT]: 'bg-present text-white',
  [TILE_STATE.ABSENT]: 'bg-absent dark:bg-absent-dark text-white',
};

const Key = ({ value, onClick, state = 'unused', wide = false }) => {
  const handleClick = useCallback(() => {
    onClick(value);
  }, [onClick, value]);

  const colorClass = stateClasses[state] || stateClasses.unused;

  return (
    <button
      onClick={handleClick}
      className={`
        ${wide ? 'px-2 sm:px-4 min-w-[50px] sm:min-w-[65px]' : 'px-1 sm:px-2.5 min-w-[28px] sm:min-w-[40px]'}
        h-12 sm:h-14 rounded-md font-bold text-xs sm:text-base
        flex items-center justify-center
        select-none cursor-pointer
        active:scale-95 transition-all duration-150
        ${colorClass}
      `}
      aria-label={value}
    >
      {value}
    </button>
  );
};

export default React.memo(Key);
